<template lang="pug">
.headerUserSubscriptionComponent
  template(v-if="!isHomepage && subscription?.isNone")
    ui-button.button(
      size="s"
      @mouseenter="open"
      @mouseleave="close"
    ) Демо
  template(v-else-if="subscription?.isDemo || (subscription?.isOver && !store.user.profile?.hasSubscriptions)")
    ui-subscription-badge.badge(
      v-if="subscription.isDemo || subscription.isOver"
      :counter="subscription.duration"
      @mouseenter="open"
      @mouseleave="close"
    )

  transition( name="fade" )
    .dropdownWrapper(
      v-if="isOpen"
      @mouseenter="open"
      @mouseleave="close"
    )
      .triangle
        ui-svg-icon(
          name="triangle-dropdown"
        )
      content-component.body

</template>

<script>
import useFlag from '@/_core/hooks/useFlag'
import ContentComponent from './HeaderUserSubscriptionContent'
import { computed, inject } from 'vue'
import { useRoute } from 'vue-router'

export default {
  components: {
    ContentComponent
  },
  inject: ['store'],
  setup () {
    const store = inject('store')
    const route = useRoute()
    const isHomepage = computed(() => route.name === 'Home')
    const subscription = computed(() => store.user.profile?.subscription)
    const { flag: isOpen, on, off } = useFlag('_opened', false)

    let shouldClose = false

    const close = () => {
      shouldClose = true
      setTimeout(() => {
        if (shouldClose) off()
      }, 300)
    }

    const open = () => {
      on()
      shouldClose = false
    }

    return {
      isOpen,
      isHomepage,
      subscription,
      open,
      close
    }
  }
}
</script>

<style lang="sass" scoped>
.fade-enter-active,
.fade-leave-active
  transition: opacity .5s ease-out

.fade-enter-from,
.fade-leave-to
  opacity: 0

.headerUserSubscriptionComponent
  position: relative
  cursor: default
  > .badge
    cursor: pointer

  > .dropdownWrapper
    position: absolute
    top: 100%
    left: 3.5*$u
    z-index: $zIndexDropdownSelect
    transform: translateY(1.5*$u)

    > .triangle
      width: 4*$u
      height: 4*$u
      transform: translateY(1*$u)
      display: flex
      color: $cWhite

    > .body
      transform: translateX(-50%)
      border-radius: $brM
      background-color: $cWhite
      padding: 3.5*$u 8*$u
      @media (max-width: $padWidth)
        transform: translateX(-75%)
</style>
